import axios from "axios";
import { Base_URL } from "../url";

export const getAllProjects = async () => {
  try {
    const response = await axios.get(`${Base_URL}/ProjectMaster/GetAllProjects`);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching projects!";
  }
};

export const getAllMerchants = async () => {
  try {
    const response = await axios.get(`${Base_URL}/MerchantMaster/GetAllMerchants`);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching merchants!";
  }
};

export const createProVenMapping = async (mappingData, userName) => {
  try {
    const response = await axios.post(
      `${Base_URL}/ProVenMapping/CreateProVenMapping?UserName=${userName}`,
      mappingData
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error creating mapping!";
  }
};